import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { axios } from '../services/baseAxios';

import { RootState } from '../redux/store';
import { UserModel } from '../redux/types/user.d';
import { toParams } from '../utils/oauthUtils';
import {getRedirectUrl, getRefreshToken} from '../utils/storageUtils';
import {authorize, getToken, redirectUri, refreshToken, responseType} from '../services/auth.service';

const responseTypeLocationKeys = {
  code: 'search',
  token: 'hash',
};

const responseTypeDataKeys = {
  code: 'code',
  token: 'access_token',
};

const useAuth = (): { user: UserModel; isAuthenticated: boolean } => {
  const history = useHistory();
  const user = useSelector((state: RootState) => state.user.user);
  const userDispatch = useDispatch().user;

  const getUser = () => {
    userDispatch
      .getUserDetailAsync()
      .then((userResult: any) => {
        if (!userResult) {
          authorize();
        } else {
          const redirectUrl = getRedirectUrl();
          if (redirectUrl) {
            const url = new URL(redirectUrl);
            history.push(`${url.pathname}${url.search}`);
          }
        }
      })
      .catch((err) => {
        console.error('useAuth:', err);
        const refresh = getRefreshToken();
        if (!refresh) {
          authorize();
        } else {
          refreshToken({ onSuccess: getUser });
        }
      });
  };

  useEffect(() => {
    if (!user) {
      if (window.location.href.indexOf(redirectUri) !== -1) {
        const locationKey = responseTypeLocationKeys[responseType];
        const search = window.location[locationKey];
        const params = toParams(search);
        const responseKey = responseTypeDataKeys[responseType];
        getToken({ code: params[responseKey], onSuccess: getUser });
        return;
      }
      axios.setToken();
      getUser();
    }
  }, [user]);
  return { user, isAuthenticated: !!user };
};

export default useAuth;
